import { Box } from '@mui/material';
import { CustomStyleCompactTable } from '../../src/components/Styles';
import NotInformation from "./NotInformation";
import React from "react";

/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

export const CustomCompactTable = ({ data = [], render, searchElement, childrenNotInformation, notInformationLegend, getRowClassName }) => {
    return (
        <Box>
            { data.length > 0 ?
                data.map((row, index) => (
                    <Box id={row?.id} key={index} sx={CustomStyleCompactTable.row(index, data.length)} className={`row ${getRowClassName?.(index, row) || ''}`}>
                        { render(row) }
                    </Box>
                ))
                :

                <NotInformation
                    text={notInformationLegend}
                    card={true}
                    searchElement={searchElement} //activates 'no_results_found' when applied
                >
                    {childrenNotInformation}
                </NotInformation>
            }
        </Box>
    );
};
